import isEqual from 'deep-equal';

import needsToAddMoreItems from '@utils/cart/needsToAddMoreItems';
import {
  CART_STATUS,
  CART_UPDATED,
  SECTION_LIST_ORIGIN,
  SECTION_TYPE,
} from './constants';

export const getCartStatus = cart => {
  if (!cart) return null;
  return needsToAddMoreItems(cart)
    ? CART_STATUS.MIN_ORDER_VALUE
    : CART_STATUS.COMPLETED;
};

export const getCartQuantity = cart => {
  if (!cart) return null;
  return cart.items
    ? cart.items.reduce((acc, item) => acc + item.quantity, 0)
    : null;
};

export const getProductQuantity = (cartItems, productId) => {
  if (!cartItems) return null;
  if (cartItems.length > 0) {
    const product = cartItems.find(
      item => item.product.toString() === productId,
    );
    return product?.quantity;
  }
  return null;
};

export const getCartOrderContent = cart => {
  if (!cart) return null;
  const content = cart.items
    ? cart.items.map(item => `${item.product},${item.quantity}`, [])
    : [];
  return content.join('|');
};

export const getCartUpdateTypeByItem = (item, prevItem) => {
  if (!item || !prevItem || item === prevItem) return [];

  const cartUpdate = [];

  if (item.quantity > prevItem.quantity)
    cartUpdate.push(CART_UPDATED.MORE_QUANTITY);
  else if (item.quantity < prevItem.quantity)
    cartUpdate.push(CART_UPDATED.LESS_QUANTITY);
  if (
    !isEqual(item.optionGroups, prevItem.optionGroups) ||
    item.notes !== prevItem.notes
  )
    cartUpdate.push(CART_UPDATED.MODIFY_PRODUCT);

  return cartUpdate;
};

export const getCartUpdateInfo = (cartItems, prevCartItems) => {
  if (!cartItems?.length || !prevCartItems) return {};

  const isDeleting = prevCartItems.length > cartItems.length;
  let cartUpdate = isDeleting ? [CART_UPDATED.DELETE_PRODUCT] : [];

  const productsUpdated = prevCartItems
    .filter(prevItem => {
      const item = cartItems.find(i => i.guid === prevItem.guid);
      if (!isEqual(item, prevItem)) {
        if (!isDeleting)
          cartUpdate = cartUpdate.concat(
            getCartUpdateTypeByItem(item, prevItem),
          );
        return true;
      }
      return false;
    })
    .map(item => item.product)
    .join(',');

  return { productsUpdated, cartUpdate: cartUpdate.join(',') };
};

export const getSectionDetailsOrigin = value => {
  if (value > SECTION_LIST_ORIGIN.SECTION_LIST_ORIGIN_VALUE)
    return SECTION_LIST_ORIGIN.SECTION_LIST_VIEW_ALL;
  return SECTION_LIST_ORIGIN.SECTION_LIST_VIEW_ALL_LINK;
};

const PAID_CUSTOM_IMAGE = SECTION_TYPE.PAID;

function setChainedData(chainData, data) {
  let chainedData = chainData;
  if (chainData === '') {
    chainedData += `${data}`;
  } else chainedData += `+${data}`;
  return chainedData;
}
function linkData(data) {
  let chaindata = '';
  data.forEach(function linkInfoData(element) {
    if (element.customImage.type === PAID_CUSTOM_IMAGE) {
      chaindata = setChainedData(chaindata, element.customImage.featureID);
    } else {
      chaindata = setChainedData(chaindata, element.id);
    }
  });
  return chaindata;
}

const NOT_SET_DATA = SECTION_TYPE.NOT_SET;

function isThereNoData(defaultData, paidData) {
  if (
    (!defaultData && !paidData) ||
    (defaultData.length === 0 && paidData.length === 0)
  ) {
    return `${NOT_SET_DATA} | ${NOT_SET_DATA}`;
  }
  return null;
}

function isOnlyDafultOrPaidData(defaultData, paidData) {
  if (paidData.length === 0 && defaultData.length > 0) {
    return `${NOT_SET_DATA}|${linkData(defaultData)}`;
  }
  if (paidData.length > 0 && defaultData.length === 0) {
    return `${linkData(paidData)}|${NOT_SET_DATA}`;
  }
  return null;
}

function DeafaultAndPaidLinkedData(defaultData, paidData) {
  if (defaultData && paidData)
    return `${linkData(paidData)}|${linkData(defaultData)}`;
  return null;
}

export const getListedInfoData = listedData => {
  const paidData = listedData.filter(
    data => data?.customImage?.type === PAID_CUSTOM_IMAGE,
  );
  const defaultData = listedData.filter(
    data => data?.customImage?.type === SECTION_TYPE.DEFAULT,
  );
  let listedInfo = isThereNoData(defaultData, paidData);
  if (!listedInfo) listedInfo = isOnlyDafultOrPaidData(defaultData, paidData);
  if (!listedInfo)
    listedInfo = DeafaultAndPaidLinkedData(defaultData, paidData);
  return listedInfo;
};

export const getCartImages = items => {
  let product = '';
  if (items?.length === 0) return null;
  items.forEach(i => {
    if (i?.image) {
      product = product.concat(`${i.product},1|`);
    } else {
      product = product.concat(`${i.product},0|`);
    }
  });
  return product;
};
